import { FC } from "react";
import { IconProps } from "./types";

export const ExclamationMark: FC<IconProps> = ({
  width = "14",
  height = "14",
  className,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <g clipPath="url(#k480qqpusa)">
      <path
        d="M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0zm.768 3.148-.127 5.465H6.529l-.122-5.465h1.361zm-.122 7.62c-.127.13-.308.195-.542.195-.234 0-.415-.065-.543-.196a.67.67 0 0 1-.191-.487c0-.2.065-.368.197-.5.13-.133.31-.199.537-.199.226 0 .405.066.537.199.13.132.197.3.197.5a.67.67 0 0 1-.192.487z"
        fill="#C6022C"
      />
    </g>
    <defs>
      <clipPath id="k480qqpusa">
        <path fill="#fff" d="M0 0h14v14H0z" />
      </clipPath>
    </defs>
  </svg>
);
